import identityIcon from "@/libs/identityIcon";
export default {
  name: "OrgUserTagSelectList",
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      identityIcon
    };
  }
};